<template>
  <div class="evaluate"
       v-if="list.length>0">
    <div class="title">
      <img class="pc-title"
           src="https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-title3.png"
           alt />
      <img class="m-title"
           src="https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-title3.png"
           alt />
    </div>
    <div class="box">
      <swiper :options="swiperOption"
              v-if="list.length>0"
              ref="mySwiper">
        <!-- slides -->
        <swiper-slide :key="index"
                      v-for="(item ,index) in list">
          <img class="item"
               :src="item.img"
               alt="轮播"
               @click="goLink(item)" />
          <div class="desc">
            <p class="desc-title">{{item.title}}</p>
            <p class="desc-detail">{{item.desc}}</p>
            <div class="desc-btn"
                 @click="goLink(item)"></div>
          </div>
        </swiper-slide>
      </swiper>
      <div id="evaluate-prev"
           class="swiper-button-prev"
           v-if="list.length>=2"
           slot="button-prev"></div>
      <div id="evaluate-next"
           class="swiper-button-next"
           v-if="list.length>=2"
           slot="button-next"></div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import XHR from '../api'

import 'swiper/dist/css/swiper.css'
export default {
  name: 'Evaluate',
  props: [],
  data: () => ({
    list: [],
    swiperOption: {
      // loop: true,
      // 滚动条
      // scrollbar: {
      //   el: '.swiper-scrollbar'
      // },
      // 上一张，下一张
      navigation: {
        nextEl: '#evaluate-next',
        prevEl: '#evaluate-prev'
      },
      // autoplay: {
      //   delay: 1000, // 秒
      //   stopOnLastSlide: false,
      //   disableOnInteraction: false
      // },
      autoplayDisableOnInteraction: false,
      autoplayStopOnLastSlide: false
    }
  }),
  components: {
    swiper,
    swiperSlide
  },
  created () {
  },
  mounted () {
    this.getEvaluate()
  },
  methods: {
    getEvaluate () {
      XHR.getEvaluate().then((res) => {
        const { status, data } = res.data
        if (status === 0) {
          this.list = data
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    goLink (item) {
      this.sendAnalytics('陕汽德龙X3000专题活动', '车型评测-查看详情', item.title)
      window.location.href = item.link
    }
  }
}
</script>
<style lang="less" scoped>
.evaluate {
  margin-top: 78px;
}
.title {
  .pc-title {
    display: none;
  }
  .m-title {
    margin: 0 auto;
    display: block;
    width: 300px;
  }
}
.box {
  position: relative;
  margin: 0 auto;
  background-size: cover;
  background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-box3.png");
  width: 540px;
  height: 697px;
  padding: 3px;
  box-sizing: border-box;
  .swiper-container {
    position: absolute;
    bottom: 3px;
    left: 3px;
    right: 3px;
    top: -1px;
    box-sizing: border-box;
    // padding: 20px 0 0 0;
    border-radius: 40px;
    .swiper-slide {
      display: flex;
      align-items: center;
      padding: 0 40px;
      box-sizing: border-box;
      flex-wrap: wrap;
      .item {
        cursor: pointer;
        height: 320px;
        width: 480px;
        box-sizing: border-box;
        border: 4px solid #f5cd94;
      }
    }
  }
  #evaluate-prev {
    outline: none;
    position: absolute;
    left: -80px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    background-size: cover;
    background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-left.png");
    width: 60px;
    height: 100px;
  }
  #evaluate-next {
    outline: none;
    position: absolute;
    right: -80px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    background-size: cover;
    background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-right.png");
    width: 60px;
    height: 100px;
  }
}
@media screen and (min-width: 751px) {
  .title {
    .pc-title {
      margin: 0 auto;
      display: block;
      width: 380px;
    }
    .m-title {
      display: none;
    }
  }
  .box {
    background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-box3.png");
    width: 1000px;
    height: 420px;
    .swiper-container {
      padding-top: 20px;
      #evaluate-prev {
        outline: none;
        position: absolute;
        left: -100px;
        top: 0;
        bottom: 0;
        margin: auto 0;
        background-size: cover;
        background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-left.png");
        width: 80px;
        height: 100px;
      }
      #evaluate-next {
        outline: none;
        position: absolute;
        right: -100px;
        top: 0;
        bottom: 0;
        margin: auto 0;
        background-size: cover;
        background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-right.png");
        width: 80px;
        height: 100px;
      }
      .desc {
        box-sizing: border-box;
        height: 320px;
        width: 400px;
        margin-left: 20px;

        .desc-title {
          font-size: 32px;
          color: rgb(255, 255, 255);
          line-height: 40px;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .desc-detail {
          font-size: 20px;
          line-height: 28px;
          color: rgba(255, 255, 255, 0.502);
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 5;
          -webkit-box-orient: vertical;
          margin-top: 13px;
          height: 140px;
        }
        .desc-btn {
          cursor: pointer;
          background-size: cover;
          background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-detail.png");
          width: 218px;
          height: 78px;
          margin-left: -10px;
          margin-top: 24px;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .swiper-container {
    padding-top: 60px;
    .desc {
      box-sizing: border-box;
      height: 320px;
      width: 100%;
      padding: 20px 0;

      .desc-title {
        font-size: 32px;
        color: rgb(255, 255, 255);
        line-height: 40px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .desc-detail {
        font-size: 24px;
        line-height: 32px;
        color: rgba(255, 255, 255, 0.502);
        // flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        margin-top: 12px;
      }
      .desc-btn {
        margin: 20px auto 10px auto;
        cursor: pointer;
        background-size: cover;
        background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-detail.png");
        width: 218px;
        height: 78px;
      }
    }
  }
}
</style>
